<div class="my-4" *ngIf="!onlyBusinessNotes">
  <div class="card card-body bg-lightgreen border p-2 px-3">
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="fs-18 7w-600 theme-text"> {{type && type==4 ? 'Special Note for Contract': 'Special Note'}}</h4>
        <button class="bg-white border hw-40 rounded-circle"  *ngIf="(!note || note.length == 0) && !addNewNote" (click)="addUpdateNote()">
          <i class="fa fa-plus"></i>
        </button>
      <div class="col-6 text-end" *ngIf="note && !addNewNote ">
        <button class="btn btn-xs btn-light mr-2" (click)="addUpdateNote()">
          <i class="fa fa-pencil"></i>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12" *ngIf="addNewNote">
        <textarea name="" id="" class="form-control" [(ngModel)]="newNote" rows="4"></textarea>
        <div class="text-end mt-3">
          <button class="btn btn-xs btn-outline rounded me-3" (click)="cancelAddUpdateNote()">Cancel</button>
          <button class="btn btn-xs btn-primary rounded " (click)="saveNote()">Save</button>
        </div>
      </div>

      <div class="col-12" *ngIf="noteData && note && !addNewNote">
        <p class="small m-0">
            {{!noteData.is_updated ? 'Created by' : 'Updated by'}}
          {{noteData.admin_name ? noteData.admin_name: ''}}
          {{noteData.date_added ? 'on ' + (noteData.date_added | date:'MM-dd-yyyy hh.mm a' : timezone) : '' }}
        </p>
        <p>{{ note }}</p>
      </div>
    </div>
  </div>
</div>


<div class="position-sticky sticky-top" style="top:60px!important" *ngIf="onlyBusinessNotes && noteData && note">
  <div class="card card-body border p-2" style="background-color:darkcyan;color:#fff">
    <div class="row align-items-center">
      <h4 class="col-6 m-0 mb-2">Special Note for Business</h4>
    </div>
    <div class="row">
      <div class="col-12" *ngIf="noteData && note && !addNewNote">
        <p class="small m-0">
            {{!noteData.is_updated ? 'Created by' : 'Updated by'}}
          {{noteData.admin_name ? noteData.admin_name: ''}}
          {{noteData.date_added ? 'on ' + (noteData.date_added | date:'MM-dd-yyyy hh.mm a' : timezone) : '' }}
        </p>
        <p>{{ note }}</p>
      </div>
    </div>
  </div>
</div>